import React from "react";
 
import { Link } from "react-router-dom"; // Import Link

const ArtificialIntelligence = () => {
  const page = {
    backgroundColor: "#05070a",
    color: "#ffffff",
    minHeight: "100vh",
    paddingTop: "120px",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    overflowX: "hidden",
    backgroundImage: `radial-gradient(circle at 20% 30%, rgba(0, 212, 255, 0.05) 0%, transparent 40%), 
                      radial-gradient(circle at 80% 70%, rgba(106, 0, 255, 0.05) 0%, transparent 40%)`,
  };

  const container = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  };

  const glass = {
    background: "rgba(255,255,255,0.02)",
    border: "1px solid rgba(255,255,255,0.08)",
    borderRadius: "24px",
    padding: "40px",
    backdropFilter: "blur(12px)",
    transition: "transform 0.3s ease",
  };

  const btnPrimary = {
    padding: "16px 44px",
    borderRadius: "50px",
    background: "#00d4ff",
    color: "#05070a",
    border: "none",
    fontWeight: "800",
    cursor: "pointer",
    fontSize: "0.9rem",
    textTransform: "uppercase",
    letterSpacing: "1px",
    boxShadow: "0 0 30px rgba(0,212,255,0.3)",
  };

  const techBadge = {
    padding: "6px 14px",
    borderRadius: "8px",
    background: "rgba(0, 212, 255, 0.1)",
    color: "#00d4ff",
    fontSize: "0.75rem",
    fontWeight: "bold",
    border: "1px solid rgba(0, 212, 255, 0.2)",
    display: "inline-block",
    marginRight: "10px",
    marginBottom: "10px",
  };

  return (
    <div style={page}>
      {/* ================= HERO SECTION ================= */}
      <section style={container}>
        <div style={{ textAlign: "center", marginBottom: "90px" }}>
          <h4 style={{ color: "#00d4ff", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "18px", fontWeight: "700", fontSize: "0.85rem" }}>
            INNOVATE • ELEVATE • ACCELERATE
          </h4>

          <h1 style={{ fontSize: "clamp(2.5rem, 6vw, 4.5rem)", fontWeight: "900", lineHeight: "1.1", marginBottom: "30px", letterSpacing: "-1px" }}>
            Cognitive Computing <br />
            <span style={{ color: "#00d4ff" }}>& Enterprise AI Solutions</span>
          </h1>

          <p style={{ fontSize: "1.15rem", color: "#a0aab4", maxWidth: "850px", margin: "0 auto 45px", lineHeight: "1.8" }}>
            Digital-X-AI integrates high-performance artificial intelligence into the corporate fabric. 
            From **Custom LLM Development** to **Autonomous Workflow Systems**, we build the 
            intelligence that scales your operational capability.
          </p>

          <div style={{ display: "flex", gap: "20px", justifyContent: "center" }}>
            {/* HYPERLINKED BUTTONS */}
            <Link to="/ai-journey" style={{ ...btnPrimary, textDecoration: 'none', textAlign: 'center' }}>
              Start AI Journey
            </Link>
            <Link to="/book-demo" style={{ ...btnPrimary, background: "transparent", color: "#ffffff", border: "1px solid rgba(255,255,255,0.2)", boxShadow: "none", textDecoration: 'none', textAlign: 'center' }}>
              Book Demo
            </Link>
          </div>
        </div>

        <div style={{ borderRadius: "32px", overflow: "hidden", border: "1px solid rgba(255,255,255,0.1)", marginBottom: "120px", boxShadow: "0 40px 80px rgba(0,0,0,0.6)" }}>
          <img src="https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1600&q=80" alt="Neural Network and AI" style={{ width: "100%", height: "550px", objectFit: "cover" }} />
        </div>
      </section>

      {/* ================= AI CORE ARCHITECTURE ================= */}
      
      <section style={{ background: "#080a0e", padding: "110px 0", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
        <div style={{ ...container, display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(420px, 1fr))", gap: "60px", alignItems: "center" }}>
          <div>
            <h2 style={{ fontSize: "2.8rem", marginBottom: "25px", fontWeight: "800" }}>
              The AI <span style={{ color: "#00d4ff" }}>Ecosystem</span>
            </h2>
            <p style={{ color: "#8b949e", lineHeight: "1.9", fontSize: "1.1rem" }}>
              We don't just "deploy" AI; we architect intelligent systems that learn from your specific 
              business data. Digital-X-AI acts as your **consultancy and implementation partner** for 
              high-impact AI transition.
            </p>
            
            <div style={{ marginTop: "30px" }}>
              <div style={techBadge}>Natural Language Processing</div>
              <div style={techBadge}>Computer Vision</div>
              <div style={techBadge}>Predictive Modeling</div>
              <div style={techBadge}>RAG Pipelines</div>
            </div>
          </div>

          <div style={glass}>
            <ul style={{ listStyle: "none", padding: 0, lineHeight: "2.5", color: "#ffffff" }}>
              <li><span style={{ color: "#00d4ff", marginRight: "10px" }}>▹</span> Custom Chatbots for 24/7 Automation</li>
              <li><span style={{ color: "#00d4ff", marginRight: "10px" }}>▹</span> Fine-Tuned LLMs (GPT-4, Llama 3)</li>
              <li><span style={{ color: "#00d4ff", marginRight: "10px" }}>▹</span> Intelligent OCR & Document Analysis</li>
              <li><span style={{ color: "#00d4ff", marginRight: "10px" }}>▹</span> Strategic AI Roadmap & Governance</li>
            </ul>
          </div>
        </div>
      </section>

      {/* ================= WHAT WE BUILD GRID ================= */}
      <section style={{ ...container, padding: "120px 0" }}>
        <h2 style={{ textAlign: "center", fontSize: "3rem", marginBottom: "70px", fontWeight: "900" }}>
          Enterprise AI Verticals
        </h2>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "30px" }}>
          <div style={glass}>
            <h3 style={{ color: "#00d4ff", fontSize: "1.4rem", marginBottom: "15px" }}>Conversational AI</h3>
            <p style={{ color: "#8b949e", fontSize: "0.95rem" }}>Next-gen customer support and internal helpdesks with full contextual memory.</p>
          </div>

          <div style={glass}>
            <h3 style={{ color: "#00d4ff", fontSize: "1.4rem", marginBottom: "15px" }}>RAG Systems</h3>
            <p style={{ color: "#8b949e", fontSize: "0.95rem" }}>Retrieval-Augmented Generation to allow AI to chat with your private business documents securely.</p>
          </div>

          <div style={glass}>
            <h3 style={{ color: "#00d4ff", fontSize: "1.4rem", marginBottom: "15px" }}>Decision Intelligence</h3>
            <p style={{ color: "#8b949e", fontSize: "0.95rem" }}>Automated forecasting and trend analysis to support C-level strategic decisions.</p>
          </div>
        </div>
      </section>

      {/* ================= FINAL CALL TO ACTION ================= */}
      <section style={{ ...container, paddingBottom: "140px" }}>
        <div style={{ background: "linear-gradient(135deg, #00d4ff 0%, #6a00ff 100%)", borderRadius: "40px", padding: "80px 40px", textAlign: "center" }}>
          <h2 style={{ fontSize: "2.8rem", color: "#05070a", fontWeight: "900", marginBottom: "15px" }}>
            Uncover the Future of Your Data
          </h2>
          <p style={{ color: "#05070a", fontWeight: "600", maxWidth: "650px", margin: "0 auto 40px", opacity: "0.8" }}>
            Schedule a strategic consultation to see how AI can optimize your project delivery and resource management.
          </p>
          <button style={{ padding: "20px 60px", borderRadius: "50px", background: "#05070a", color: "#ffffff", border: "none", fontWeight: "800", cursor: "pointer", fontSize: "1rem", textTransform: "uppercase" }}>
            Consult Our AI Architects
          </button>
        </div>
      </section>
    </div>
  );
};

export default ArtificialIntelligence;